<div class="flex gap-[1rem] items-center justify-between md:justify-end mb-[2.5rem] md:mb-[1rem] redeemable">
  <div class="text-base md:text-lg font-normal">{{ 'rewards.rewardsRedeemableIn' | translate }}</div>
  <div class="flex gap-[0.75rem]">
    <div
      class="w-[2rem] h-[2rem] md:w-[2.25rem] md:h-[2.25rem] rounded-full redeemable-in cursor-pointer"
      [class.selected]="selectedRedeemableIn === 'usa'"
      (click)="onRedeemableInClick('usa')"
    >
      <img src="/assets/img/rewards/us.png" class="w-full h-full" />
    </div>
    <div
      class="w-[2rem] h-[2rem] md:w-[2.25rem] md:h-[2.25rem] rounded-full redeemable-in cursor-pointer"
      [class.selected]="selectedRedeemableIn === 'mx'"
      (click)="onRedeemableInClick('mx')"
    >
      <img src="/assets/img/rewards/mx.png" class="w-full h-full" />
    </div>
  </div>
</div>
